<template>
  <div class="transfer">
    <v-app>
      <div v-if="!userid">
        <v-container>
          <v-alert :value="true" color="warning" icon="priority_high" outline>
            {{ $t('Not found this page') }}
          </v-alert>
        </v-container>
      </div>
      <div v-else-if="isCompleted">
        <cover>
          <div slot="body" style="text-align: center; margin-top: -95px">
            <img
              src="@/assets/img/ecommerce/shopping_cart@4x.png"
              alt="shopping cart"
              style="width: 140px; padding-bottom: 10px"
            />
            <p style="padding-bottom: 10px">{{ $t('Payment Successfully') }}</p>
            <v-btn outline :color="theme.color" @click="goToShop()">
              {{ $t('Continue Shopping') }}
            </v-btn>
          </div>
        </cover>
      </div>
      <!-- <div v-else-if="isEmptyShoppingCart">
        <cover>
          <div slot="body" style="margin-left: -93px;text-align: center;margin-top: -95px;">
            <img
              src="../assets/img/ecommerce/empty_shopping_cart@4x.png"
              alt="empty shopping cart"
              style="width: 140px;padding-bottom: 10px;"
            >
            <p style="padding-bottom: 10px">{{$t('There are no items in this cart')}}</p>
            <v-btn
              outline
              :color="theme.color"
              @click="goToShop()"
            >{{$t('Continue Shopping')}}</v-btn>
          </div>
        </cover>
      </div>-->
      <div v-else-if="isEmptyShoppingCart">
        <cover>
          <div slot="body" style="text-align: center; margin-top: -95px">
            <img
              src="@/assets/img/ecommerce/shopping_cart_out@4x.png"
              alt="empty shopping cart"
              style="width: 140px; padding-bottom: 10px"
            />
            <p style="padding-bottom: 10px">
              {{ $t('This order has been reset, please try to order again.') }}
            </p>

            <v-btn outline :color="theme.color" @click="goToShop()">
              {{ $t('Continue Shopping') }}
            </v-btn>
          </div>
        </cover>
      </div>
      <!-- <div v-else-if="pageLoading" style="height: 100vh">
        <v-layout justify-center align-center style="height: 100%">
          <v-progress-circular
            :key="theme.color"
            :size="70"
            :width="7"
            :color="theme.color"
            indeterminate
          ></v-progress-circular>
        </v-layout>
      </div>-->
      <div v-else>
        <merchant-detail v-model="pageProfile"></merchant-detail>
        <form
          id="checkout-form"
          class="checkout-form"
          method="POST"
          @submit.prevent="handleSubmit"
        >
          <v-container class="mt-5">
            <v-layout wrap row>
              <v-flex xs12 sm6 offset-sm3>
                <h3 class="headline" :style="{ color: theme.color }">
                  {{ $t('Payment') }}
                </h3>
                <br />
              </v-flex>
              <v-flex xs12 sm6 offset-sm3>
                <div
                  :class="{ 'has-error': errors.has('first_name') }"
                  class="mb-1"
                >
                  <v-text-field
                    :label="$t('ชื่อจริง')"
                    :data-vv-as="$t('ชื่อจริง')"
                    outline
                    name="first_name"
                    v-validate="'required'"
                    v-model="inputBec.first_name"
                    light
                    :color="theme.color"
                    :error="errors.has('first_name') ? true : false"
                    :error-messages="
                      errors.has('first_name') ? errors.first('first_name') : ''
                    "
                  ></v-text-field>
                </div>
                <div
                  :class="{ 'has-error': errors.has('last_name') }"
                  class="mb-1"
                >
                  <v-text-field
                    :label="$t('นามสกุล')"
                    :data-vv-as="$t('นามสกุล')"
                    outline
                    name="last_name"
                    v-validate="'required'"
                    v-model="inputBec.last_name"
                    light
                    :color="theme.color"
                    :error="errors.has('last_name') ? true : false"
                    :error-messages="
                      errors.has('last_name') ? errors.first('last_name') : ''
                    "
                  ></v-text-field>
                </div>
                <div
                  :class="{ 'has-error': errors.has('customerPhone') }"
                  class="mb-1"
                >
                  <v-text-field
                    :label="$t('Tel.')"
                    :data-vv-as="$t('Tel.')"
                    outline
                    tyle="tel"
                    name="customerPhone"
                    light
                    :color="theme.color"
                    v-validate="{
                      required: true,
                      regex:
                        /((\(?(\+\s*)([0-9]{2,3})\)?\s*[0]?)|[0])(([1-9][0-9]?))\s*\-?\s*([0-9]{3})\s*\-?\s*([0-9]{4,5})/
                    }"
                    v-model="customerPhone"
                    :error="errors.has('customerPhone') ? true : false"
                    :error-messages="
                      errors.has('customerPhone')
                        ? errors.first('customerPhone')
                        : ''
                    "
                  ></v-text-field>
                </div>
                <div :class="{ 'has-error': errors.has('email') }" class="mb-1">
                  <v-text-field
                    :label="$t('Email')"
                    :data-vv-as="$t('Email')"
                    outline
                    name="email"
                    light
                    :color="theme.color"
                    v-validate="{
                      required: true,
                      email: true
                    }"
                    v-model="inputBec.email"
                    :error="errors.has('email') ? true : false"
                    :error-messages="
                      errors.has('email') ? errors.first('email') : ''
                    "
                  ></v-text-field>
                </div>
                <div
                  :class="{ 'has-error': errors.has('รหัสไปรษณีย์') }"
                  class="mb-1"
                >
                  <thai-address-input
                    v-model="shippingAddress2.zipcode"
                    type="zipcode"
                    @select="onSelectAddress"
                    :label="$t('รหัสไปรษณีย์')"
                    :data-vv-as="$t('รหัสไปรษณีย์')"
                    outline
                    name="รหัสไปรษณีย์"
                    v-validate="'required'"
                    light
                    :color="theme.color"
                    :error="errors.has('รหัสไปรษณีย์') ? true : false"
                    :error-messages="
                      errors.has('รหัสไปรษณีย์')
                        ? errors.first('รหัสไปรษณีย์')
                        : ''
                    "
                  ></thai-address-input>
                </div>
                <div
                  :class="{ 'has-error': errors.has('จังหวัด') }"
                  class="mb-1"
                >
                  <thai-address-input
                    v-model="shippingAddress2.province"
                    type="province"
                    @select="onSelectAddress"
                    :label="$t('จังหวัด')"
                    :data-vv-as="$t('จังหวัด')"
                    outline
                    name="จังหวัด"
                    v-validate="'required'"
                    light
                    :color="theme.color"
                    :error="errors.has('จังหวัด') ? true : false"
                    :error-messages="
                      errors.has('จังหวัด') ? errors.first('จังหวัด') : ''
                    "
                  ></thai-address-input>
                </div>
                <div :class="{ 'has-error': errors.has('เขต') }" class="mb-1">
                  <thai-address-input
                    v-model="shippingAddress2.district"
                    type="amphoe"
                    @select="onSelectAddress"
                    :label="$t('เขต')"
                    :data-vv-as="$t('เขต')"
                    outline
                    name="เขต"
                    v-validate="'required'"
                    light
                    :color="theme.color"
                    :error="errors.has('เขต') ? true : false"
                    :error-messages="
                      errors.has('เขต') ? errors.first('เขต') : ''
                    "
                  ></thai-address-input>
                </div>
                <div :class="{ 'has-error': errors.has('แขวง') }" class="mb-1">
                  <thai-address-input
                    v-model="shippingAddress2.sub_district"
                    type="district"
                    @select="onSelectAddress"
                    :label="$t('แขวง')"
                    :data-vv-as="$t('แขวง')"
                    outline
                    name="แขวง"
                    v-validate="'required'"
                    light
                    :color="theme.color"
                    :error="errors.has('แขวง') ? true : false"
                    :error-messages="
                      errors.has('แขวง') ? errors.first('แขวง') : ''
                    "
                  ></thai-address-input>
                </div>
                <div
                  v-if="isOoca"
                  :class="{ 'has-error': errors.has('emailAddress') }"
                  class="mb-1"
                >
                  <v-text-field
                    outline
                    :label="$t('Email Address')"
                    name="emailAddress"
                    rows="5"
                    :data-vv-as="$t('Email Address')"
                    style="resize: none; width: 100%"
                    v-model="shippingAddress"
                    v-validate="{ required: true, email: true }"
                    light
                    :color="theme.color"
                    :error="errors.has('emailAddress') ? true : false"
                    :error-messages="
                      errors.has('emailAddress')
                        ? errors.first('emailAddress')
                        : ''
                    "
                  ></v-text-field>
                </div>
                <div
                  v-else
                  :class="{ 'has-error': errors.has('shippingAddress') }"
                  class="mb-1"
                >
                  <v-textarea
                    outline
                    :label="$t('Shipping Address')"
                    name="shippingAddress"
                    rows="5"
                    :data-vv-as="$t('Shipping Address')"
                    style="resize: none; width: 100%"
                    v-model="shippingAddress"
                    v-validate="{
                      required: true,
                      isBearhousezipcode: [cart.length, isBearhouse]
                    }"
                    light
                    :placeholder="
                      $t('กรุณาระบุเฉพาะ บ้านเลขที่, อาคาร/หมู่บ้าน, ซอย, ถนน')
                    "
                    :color="theme.color"
                    :error="errors.has('shippingAddress') ? true : false"
                    :error-messages="
                      errors.has('shippingAddress')
                        ? errors.first('shippingAddress')
                        : ''
                    "
                  ></v-textarea>
                </div>

                <div
                  v-if="$store.state.cds.includes(pageid)"
                  :class="{ 'has-error': errors.has('remark') }"
                >
                  <v-text-field
                    outline
                    :label="$t('The 1 Card Number') + ` (${$t('Optional')})`"
                    name="remark"
                    :data-vv-as="$t('The 1 Card Number')"
                    style="resize: none; width: 100%"
                    v-model="remark"
                    :color="theme.color"
                    light
                  ></v-text-field>
                </div>

                <template
                  v-if="
                    pageProfile && pageProfile.pageid && shippinglist && !isOoca
                  "
                >
                  <shipping-type
                    :key="key"
                    :bearhouseshippingprice="bearhouseshippingprice"
                    :cdsshippingprice="cdsshippingprice"
                    v-model="shippingType"
                    :shippinglist="thpostmartShippingprice"
                    :additionalproduct_charge="additionalproduct_charge"
                    :pageid="pageProfile.pageid"
                    :total="totalincludediscount"
                  ></shipping-type>
                </template>
              </v-flex>
            </v-layout>
          </v-container>
          <v-divider></v-divider>
          <v-container class="mt-3">
            <v-layout wrap row>
              <v-flex xs12 sm6 offset-sm3>
                <h3
                  class="headline mb-3 text-xs-center"
                  :style="{ color: theme.color }"
                >
                  {{ $t('Payment Detail') }}
                </h3>
                <cart-summary
                  :cdsshippingprice="cdsshippingprice"
                  :bearhouseshippingprice="bearhouseshippingprice"
                  :total="total"
                  :totalincludediscount="totalincludediscount"
                  :discount="discount"
                  :shippingType="shippingType"
                  :additionalproduct_charge="additionalproduct_charge"
                ></cart-summary>
                <template>
                  <v-layout>
                    <v-flex class="mb-2 my-input">
                      <v-text-field
                        outline
                        :color="theme.color"
                        v-model="voucherCode"
                        :label="$t('Input voucher code')"
                        maxlength="20"
                      ></v-text-field>
                    </v-flex>
                    <v-flex shrink>
                      <v-btn
                        ref="voucherBtn"
                        style="color: #ffffff"
                        :color="theme.color"
                        @click="onCheckVoucher()"
                        x-large
                        :disabled="!voucherCode || voucherCode == ''"
                        :loading="loading"
                      >
                        {{ $t('Apply') }}
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </template>
                <div
                  v-if="!$store.state.cds.includes(pageid)"
                  :class="{ 'has-error': errors.has('remark') }"
                  style="margin-bottom: 15px"
                >
                  <v-textarea
                    outline
                    :label="$t('Remark')"
                    name="remark"
                    rows="5"
                    :data-vv-as="$t('Remark')"
                    style="resize: none; width: 100%"
                    v-model="remark"
                    :color="theme.color"
                    light
                  ></v-textarea>
                </div>
                <div>
                  <div style="padding-bottom: 25px">
                    <v-card>
                      <v-card-text>
                        <!-- Cash on Delivery -->
                        <template
                          v-if="
                            shippingType && shippingType.type == 'cod_charge'
                          "
                        >
                          <h3 class="text-xs-center">{{ $t('cod_charge') }}</h3>

                          <div
                            class="text-xs-center"
                            style="padding-top: 15px; padding-bottom: 15px"
                          >
                            <a
                              href="javascript:void(0);"
                              @click="openModal()"
                              style="color: rgb(169, 169, 169)"
                            >
                              {{
                                $t('By clicking Proceed Payment, Ive read and')
                              }}
                              <br />
                              {{ $t('agree to') }}
                              <span :style="{ color: theme.color }">
                                {{
                                  $t('Terms & Condition & Refund Prolicy')
                                }} </span
                              >.
                            </a>
                          </div>
                          <template v-if="loading">
                            <div class="text-xs-center my-3">
                              <v-progress-circular
                                :key="theme.color"
                                indeterminate
                                :color="theme.color"
                              ></v-progress-circular>
                            </div>
                          </template>
                          <template v-else>
                            <p
                              class="text-xs-center"
                              style="color: red"
                              v-if="isCartOutOfStock"
                            >
                              {{
                                $t(
                                  'Not enough products in stock, please try to order again.'
                                )
                              }}.
                            </p>
                            <div class="text-xs-center">
                              <v-btn
                                dark
                                :color="theme.color"
                                :disabled="loading || isCartOutOfStock"
                                @click="handleSubmit"
                                :loading="pageLoading"
                              >
                                <v-icon class="mr-2">mdi-cart-outline</v-icon>
                                {{ $t('Proceed Payment') }}
                              </v-btn>
                            </div>
                          </template>
                        </template>
                        <template v-else>
                          <template>
                            <v-layout row wrap class="mb-3">
                              <v-flex
                                :xs6="paymentList.length > 1"
                                :xs12="paymentList.length == 1"
                                class="px-1"
                                v-if="
                                  paymentList.includes('gbprime') &&
                                  paymentList.length > 1
                                "
                              >
                                <h3
                                  v-if="paymentList.length == 1"
                                  class="text-xs-center"
                                >
                                  <v-icon small class="mr-2"
                                    >mdi-qrcode-scan</v-icon
                                  >
                                  <b>QR CODE</b>
                                </h3>
                                <v-btn
                                  v-else
                                  :color="theme.color"
                                  dark
                                  block
                                  small
                                  @click="
                                    transferType = 'qrcode'
                                    setShippingDefault()
                                  "
                                  :outline="transferType != 'qrcode'"
                                >
                                  <v-icon small class="mr-2"
                                    >mdi-qrcode-scan</v-icon
                                  >QR CODE
                                </v-btn>
                              </v-flex>
                              <v-flex
                                :xs6="paymentList.length > 1"
                                :xs12="paymentList.length == 1"
                                class="px-1"
                                v-if="
                                  paymentList.includes('transfer') &&
                                  paymentList.length > 1
                                "
                              >
                                <template v-if="paymentList.length == 1">
                                  <h3 class="text-xs-center">
                                    {{ $t('transfer') }}
                                  </h3>
                                </template>
                                <template v-else>
                                  <v-btn
                                    v-if="!showOnlyQRpage"
                                    :color="theme.color"
                                    dark
                                    block
                                    small
                                    @click="
                                      transferType = 'transfer'
                                      setShippingDefault()
                                    "
                                    :outline="transferType != 'transfer'"
                                  >
                                    <v-icon small class="mr-2"
                                      >mdi-cash-multiple</v-icon
                                    >
                                    {{ $t('transfer') }}
                                  </v-btn>
                                </template>
                              </v-flex>
                              <v-flex
                                :xs6="paymentList.length > 1"
                                :xs12="paymentList.length == 1"
                                class="px-1"
                                v-if="
                                  paymentList.includes('2c2p') &&
                                  paymentList.length > 1
                                "
                              >
                                <v-btn
                                  :color="theme.color"
                                  dark
                                  small
                                  block
                                  v-if="
                                    $store.state.page2c2p.includes(pageid) ||
                                    paymentList.includes('2c2p')
                                  "
                                  @click="
                                    transferType = '2c2p'
                                    setShippingDefault()
                                  "
                                  :outline="transferType != '2c2p'"
                                >
                                  <template>
                                    <v-icon small class="mr-2"
                                      >mdi-credit-card</v-icon
                                    >
                                    {{ $t('2C2P Payment') }}
                                  </template>
                                </v-btn>
                                <v-btn
                                  :color="theme.color"
                                  dark
                                  small
                                  block
                                  v-else-if="$store.state.cds.includes(pageid)"
                                  @click="
                                    transferType = 'fbpay'
                                    setShippingDefault()
                                  "
                                  :outline="transferType != 'fbpay'"
                                >
                                  <template>
                                    <v-icon small class="mr-2"
                                      >mdi-credit-card</v-icon
                                    >
                                    {{ $t('Credit Cards') }}
                                  </template>
                                </v-btn>
                              </v-flex>
                              <v-flex
                                :xs6="paymentList.length > 1"
                                :xs12="paymentList.length == 1"
                                class="px-1"
                                v-if="
                                  paymentList.includes('fbpay') &&
                                  paymentList.length > 1
                                "
                              >
                                <v-btn
                                  :color="theme.color"
                                  dark
                                  small
                                  block
                                  @click="
                                    transferType = 'fbpay'
                                    setShippingDefault()
                                  "
                                  :outline="transferType != 'fbpay'"
                                >
                                  <template>
                                    <v-icon small class="mr-2"
                                      >mdi-cellphone-android</v-icon
                                    >
                                    {{ $t('Mobile Banking') }}
                                  </template>
                                </v-btn>
                              </v-flex>
                              <v-flex
                                :xs6="paymentList.length > 1"
                                :xs12="paymentList.length == 1"
                                class="px-1"
                                v-if="
                                  paymentList.includes('cod') &&
                                  paymentList.length > 1
                                "
                              >
                                <template v-if="paymentList.length == 1">
                                  <h3 class="text-xs-center">
                                    {{ $t('cod_charge') }}
                                  </h3>
                                </template>
                                <v-btn
                                  v-else
                                  :color="theme.color"
                                  dark
                                  small
                                  block
                                  @click="
                                    transferType = 'cod_charge'
                                    setShippingDefault('cod_charge')
                                  "
                                  :outline="transferType != 'cod_charge'"
                                >
                                  <v-icon small class="mr-2"
                                    >mdi-package-variant-closed</v-icon
                                  >
                                  {{ $t('cod_charge') }}
                                </v-btn>
                              </v-flex>
                              <v-flex
                                :xs6="paymentList.length > 1"
                                :xs12="paymentList.length == 1"
                                v-if="
                                  paymentList.includes('paypal') &&
                                  paymentList.length > 1
                                "
                                class="px-1"
                              >
                                <v-btn
                                  :color="theme.color"
                                  dark
                                  block
                                  small
                                  @click="
                                    transferType = 'paypal'
                                    renderPaypalBtn()
                                    setShippingDefault()
                                  "
                                  :outline="transferType != 'paypal'"
                                >
                                  <v-icon small class="mr-2"
                                    >mdi-credit-card</v-icon
                                  >
                                  {{ $t('Credit Cards') }}
                                </v-btn>
                              </v-flex>
                            </v-layout>
                            <div v-if="['transfer'].includes(transferType)">
                              <div class="mb-4">
                                <template v-if="banktransferinfo_photo">
                                  <img
                                    :src="banktransferinfo_photo"
                                    alt="bank transfer"
                                    style="
                                      border: 1px solid #eee;
                                      border-radius: 5px;
                                      margin-bottom: 15px;
                                      width: 100%;
                                    "
                                  />
                                </template>
                                <template v-if="banktransferinfo">
                                  <bank-number
                                    :text="banktransferinfo"
                                  ></bank-number>
                                </template>
                              </div>

                              <div
                                :class="{
                                  'has-error': errors.has('paymentSlipImage')
                                }"
                                class="mb-4"
                                v-if="
                                  !shippingType ||
                                  (shippingType &&
                                    shippingType.type != 'cod_charge')
                                "
                              >
                                <h3
                                  class="headline"
                                  :style="{ color: theme.color }"
                                >
                                  {{ $t('Payment slip') }}
                                </h3>
                                <br />
                                <template v-if="!isCartOutOfStock">
                                  <upload-file
                                    :outputtype="
                                      isCDS || pageProfile.type == 'monobo'
                                        ? 'base64'
                                        : 'url'
                                    "
                                    name="paymentSlipImage"
                                    v-validate="'required'"
                                    :data-vv-as="$t('Payment Slip Image')"
                                    v-model="paymentSlipImage"
                                  ></upload-file>
                                </template>
                                <p
                                  class="caption ma-2"
                                  style="color: red"
                                  v-show="errors.has('paymentSlipImage')"
                                >
                                  {{ errors.first('paymentSlipImage') }}
                                </p>
                              </div>

                              <div
                                v-if="pageProfile.type == 'monobo'"
                                :class="{ 'has-error': errors.has('bankname') }"
                                style="margin-bottom: 15px"
                              >
                                <v-select
                                  v-model="bankname"
                                  outline
                                  label="บัญชีที่ลูกค้าทำการชำระ"
                                  key="บัญชี"
                                  data-vv-as="บัญชีที่ลูกค้าทำการชำระ"
                                  v-validate="'required'"
                                  :items="monobobanklist"
                                  name="bankname"
                                  :error="errors.has('bankname') ? true : false"
                                  :error-messages="
                                    errors.has('bankname')
                                      ? errors.first('bankname')
                                      : ''
                                  "
                                ></v-select>
                                <!-- <v-textarea
                                  outline
                                  :label="$t('Remark')"
                                  name="remark"
                                  rows="5"
                                  :data-vv-as="$t('Remark')"
                                  style="resize: none;width:100%"
                                  v-model="remark"
                                  :color="theme.color"
                                  light
                                ></v-textarea>-->
                              </div>
                            </div>
                            <div>
                              <form
                                ref="form2c2p"
                                id="2c2p-payment-form"
                                method="POST"
                                :action="`https://2c2pgateway.zwiz.ai/becredirectapi.php?date=${new Date()}`"
                              >
                                <input
                                  type="hidden"
                                  v-model="orderid"
                                  name="orderid"
                                />
                                <input
                                  type="hidden"
                                  v-model="refid"
                                  name="refid"
                                />
                                <input
                                  type="hidden"
                                  v-model="amount"
                                  name="amount"
                                />
                                <input type="hidden" value="bec" name="theme" />
                                <input
                                  type="hidden"
                                  v-model="pageid"
                                  name="pageid"
                                />
                                <input
                                  type="hidden"
                                  v-model="serverUrl"
                                  name="serverUrl"
                                />
                              </form>
                            </div>
                            <div
                              class="text-xs-center"
                              style="padding-top: 15px; padding-bottom: 15px"
                            >
                              <a
                                href="javascript:void(0);"
                                @click="openModal()"
                                style="color: rgb(169, 169, 169)"
                              >
                                {{
                                  $t(
                                    'By clicking Proceed Payment, Ive read and'
                                  )
                                }}
                                <br />
                                {{ $t('agree to') }}
                                <span :style="{ color: theme.color }">
                                  {{
                                    $t('Terms & Condition & Refund Prolicy')
                                  }} </span
                                >.
                              </a>
                            </div>
                            <template v-if="loading">
                              <div class="text-xs-center my-3">
                                <v-progress-circular
                                  :key="theme.color"
                                  indeterminate
                                  :color="theme.color"
                                ></v-progress-circular>
                              </div>
                            </template>
                            <template v-else>
                              <p
                                class="text-xs-center"
                                style="color: red"
                                v-if="isCartOutOfStock"
                              >
                                {{
                                  $t(
                                    'Not enough products in stock, please try to order again.'
                                  )
                                }}.
                              </p>
                              <div class="text-xs-center">
                                <v-btn
                                  v-if="isCDS && transferType == '2c2p'"
                                  dark
                                  :color="theme.color"
                                  :disabled="loading || isCartOutOfStock"
                                  @click="handleSubmit"
                                  :loading="pageLoading"
                                >
                                  <v-icon class="mr-2">mdi-cart-outline</v-icon>
                                  {{ $t('Proceed Payment') }}
                                </v-btn>
                                <v-btn
                                  dark
                                  v-else-if="
                                    [
                                      '115414076948160',
                                      '396306053873110'
                                    ].includes(pageProfile.pageid)
                                  "
                                  :color="theme.color"
                                  :disabled="loading || isCartOutOfStock"
                                  @click="handleSubmitTHPostmart"
                                  :loading="pageLoading"
                                >
                                  <v-icon class="mr-2">mdi-cart-outline</v-icon>
                                  {{ $t('Proceed Payment') }}
                                </v-btn>
                                <v-btn
                                  dark
                                  v-else
                                  :color="theme.color"
                                  :disabled="loading || isCartOutOfStock"
                                  @click="handleSubmit"
                                  :loading="pageLoading"
                                >
                                  <v-icon class="mr-2">mdi-cart-outline</v-icon>
                                  {{ $t('Proceed Payment') }}
                                </v-btn>
                              </div>
                            </template>
                          </template>
                        </template>
                      </v-card-text>
                    </v-card>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </form>
      </div>
    </v-app>
    <Loading v-if="!pageLoading && loading"></Loading>
    <term-and-condition
      :pageid="pageProfile.pageid"
      v-if="showTerm"
      @close="close()"
    ></term-and-condition>
    <v-dialog v-model="showQrCode" max-width="376" persistent>
      <v-card>
        <div class="text-xs-right">
          <v-btn fab small flat @click="closeQrCode">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <template v-if="qrimage">
            <img :src="qrimage" style="width: 100%" />
            <div class="text-xs-center mt-2">
              {{
                $t(
                  'If you already have proceeded a payment, you may close this popup window.'
                )
              }}
            </div>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import MainTransfer from '../MainTransfer'
import ThaiAddressInput from '@/components/ThaiAddressInput'
import config from '@/config'
import axios from 'axios'
import moment from 'moment'
import VoucherCodeInput from '@/components/ecommerce/VoucherCodeInput'

export default {
  mixins: [MainTransfer],
  components: {
    ThaiAddressInput,
    VoucherCodeInput
  },
  computed: {
    query() {
      return this.$route.query
    },
    thpostmartShippingprice() {
      let tempShippingList = this.shippinglist
      // const shippingPrice = this.$store.state.thpostmartVerifyCartResult
      //   ? this.$store.state.thpostmartVerifyCartResult[0].desc[0].shipping_total
      //   : 0
      tempShippingList.normal_charge[0] = this.thpostDeliveryPrice
      return tempShippingList
    }
  },
  data() {
    return {
      transferType: '',
      inputBec: {
        first_name: '',
        last_name: '',
        province: '',
        district: '',
        sub_district: '',
        zipcode: '',
        address: '',
        phoneno: '',
        email: ''
      },
      voucherCode: null,
      shippingPrice: 0,
      thpostDeliveryPrice: 0,
      key: 1
    }
  },
  async mounted() {
    if (!['tero'].includes(this.pageProfile.type)) {
      if (this.shippingAddress && this.shippingAddress2) {
        this.handleCheckShippingPrice()
      }
    }
  },
  methods: {
    onSelectAddress(address) {
      this.shippingAddress2.sub_district = address.district
      this.shippingAddress2.district = address.amphoe
      this.shippingAddress2.province = address.province
      this.shippingAddress2.zipcode = address.zipcode

      if (!['tero'].includes(this.pageProfile.type)) {
        this.handleCheckShippingPrice()
      }
    },
    handleSubmit: function () {
      let vm = this
      vm.$validator.validate().then((result) => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }
        if (vm.isEmptyShoppingCart) {
          return false
        }

        vm.loading = true
        var total = vm.total
        if (vm.shippingType) {
          total += vm.shippingType.value
        }
        var payment
        if (vm.shippingType && vm.shippingType.type == 'cjlogistics_charge') {
          payment = '2c2p'
        } else {
          payment = vm.transferType
        }
        var combine_address = ''
        combine_address = this.shippingAddress.replace(/,/g, '')
        if (
          !this.useOldAddress.includes(this.pageProfile.pageid) &&
          this.shippingAddress2.sub_district &&
          this.shippingAddress2.district &&
          this.shippingAddress2.province &&
          this.shippingAddress2.zipcode
        ) {
          var inBangkok = this.shippingAddress2.province == 'กรุงเทพมหานคร'
          combine_address =
            combine_address +
            ' , ' +
            [
              (inBangkok ? 'แขวง' : 'ตำบล') +
                this.shippingAddress2.sub_district.replace(/,/g, ''),
              (inBangkok ? 'เขต' : 'อำเภอ') +
                this.shippingAddress2.district.replace(/,/g, ''),
              'จังหวัด' + this.shippingAddress2.province.replace(/,/g, ''),
              this.shippingAddress2.zipcode.replace(/,/g, '')
            ].join(' , ')
        }

        var note = this.paymentSlipImage
        var customerName = vm.inputBec.first_name + ' ' + vm.inputBec.last_name
        let data = {
          amount: vm.totalPrice.toFixed(2).toString().replace('.', ''),
          pageid: vm.pageid,
          userid: vm.userid,
          app: vm.app,
          name: customerName,
          email: vm.inputBec.email,
          address: combine_address,
          phone: vm.customerPhone,
          payment: payment,
          nameaddress:
            customerName + ' , ' + combine_address + ' , ' + vm.customerPhone,
          shippingtype: vm.shippingType ? vm.shippingType.type : null,
          note: note,
          remark:
            this.pageProfile.type == 'monobo'
              ? this.remark + ';;' + this.bankname
              : this.remark,
          shippingcharge: (vm.shippingType ? vm.shippingType.value : 0)
            .toFixed(2)
            .toString()
            .replace('.', ''),
          total: total.toFixed(2).toString().replace('.', '')
        }
        data = {
          ...data,
          becaddress: {
            name: customerName,
            address: this.shippingAddress,
            tumbol_name: this.shippingAddress2.sub_district,
            amphur_name: this.shippingAddress2.district,
            province_name: this.shippingAddress2.province,
            postcode: this.shippingAddress2.zipcode,
            phone: this.customerPhone,
            remark: this.remark,
            email: this.inputBec.email
          }
        }
        let url

        data.cart_ids = this.$store.state.cart_ids || []

        url = config.getConfig('serverUrl') + 'banktransfernotify'

        if (vm.sessiontoken != null || vm.sessiontoken != '') {
          url += '?sessiontoken=' + vm.sessiontoken
        }
        axios
          .post(url, data)
          .then((response) => {
            // JSON responses are automatically parsed.
            response = response.data
            if (response.responsecode == 200) {
              if (payment == '2c2p' && vm.shippingType.type !== 'cod_charge') {
                vm.orderid = response.orderid
                vm.amount = data.total
                this.$nextTick(() => {
                  vm.$refs.form2c2p.submit()
                })
              } else {
                vm.isCompleted = true
                vm.$store.dispatch('deleteAllItemsInCart')
                // eslint-disable-next-line
                if (vm.$liff.isInClient()) {
                  // eslint-disable-next-line no-undef
                  vm.$liff
                    .sendMessages([
                      {
                        type: 'text',
                        text: 'Order: ' + response.orderid
                      }
                    ])
                    .then(() => {})
                  // eslint-disable-next-line no-undef
                  vm.$liff.closeWindow()
                } else {
                  // eslint-disable-next-line no-undef
                  MessengerExtensions.requestCloseBrowser(
                    function success() {},
                    function error() {
                      window.close()
                    }
                  )
                }
              }
            } else if (response.responsecode == 400) {
              vm.$swal({
                title: vm.$t('Error'),
                text: vm.$t(response.reason),
                type: 'error',
                confirmButtonText: vm.$t('Confirm'),
                cancelButtonText: vm.$t('Cancel'),
                reverseButtons: true
              })
            } else if (response.responsecode == 201) {
              vm.isCompleted = true
              vm.$store.dispatch('deleteAllItemsInCart')
              let url = '/ecommerce/' + vm.pagename
              if (vm.userid && vm.userid != null && vm.userid != '') {
                url += '?userid=' + vm.userid
              }
              vm.$router.push({ path: url })
            } else {
              vm.$swal({
                title: vm.$t('Error'),
                text: vm.$t('Something went wrong. Please try it again..'),
                type: 'error',
                confirmButtonText: vm.$t('Confirm'),
                cancelButtonText: vm.$t('Cancel'),
                reverseButtons: true
              })
            }
            vm.loading = false
          })
          .catch((err) => {
            /* eslint-disable */
            console.log(err)

            vm.loading = false
            vm.$swal({
              title: vm.$t('Error'),
              text: vm.$t('Something went wrong. Please try it again.'),
              type: 'error',
              confirmButtonText: vm.$t('Confirm'),
              cancelButtonText: vm.$t('Cancel'),
              reverseButtons: true
            })
          })
      })
    },
    handleSubmitTHPostmart: function () {
      let vm = this
      vm.$validator.validate().then(async (result) => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }
        if (vm.isEmptyShoppingCart) {
          return false
        }

        vm.loading = true

        try {
          var payment
          if (vm.shippingType && vm.shippingType.type == 'cjlogistics_charge') {
            payment = '2c2p'
          } else {
            payment = vm.transferType
          }
          let responseSubmit = await vm.THPostMartSubmitOrder()
          vm.loading = false
          if (responseSubmit) {
            vm.$store.dispatch('deleteAllItemsInCart')
            if (payment == '2c2p' && vm.shippingType.type !== 'cod_charge') {
              let tempAmountTotal =
                vm.$store.state.thpostmartVerifyCartResult[0].desc[0]
                  .amount_total
              const amountTotal = tempAmountTotal
                ? tempAmountTotal.replace(',', '')
                : 0
              vm.orderid = responseSubmit[0].order_id_thp
              vm.amount = parseFloat(amountTotal) * 100

              this.$nextTick(() => {
                vm.$refs.form2c2p.submit()
              })
            }
          }
        } catch (error) {
          /* eslint-disable */
          console.log(error)
        }
      })
    },
    async handleCheckShippingPrice() {
      try {
        const response = await this.THPostMartVerifyCart()

        if (
          response[0] &&
          response[0].desc &&
          response[0].desc[0] &&
          Object.keys(response[0].desc[0]).length
        ) {
          this.thpostDeliveryPrice = response[0].desc[0].shipping_total
          this.key++
        }
      } catch (error) {
        console.error(error)
      }
    },
    async THPostMartVerifyCart() {
      const vm = this

      let address =
        this.shippingAddress +
        ' ' +
        this.shippingAddress2.sub_district +
        ' ' +
        this.shippingAddress2.district +
        ' ' +
        this.shippingAddress2.province
      let customerName =
        this.inputBec.first_name + ' ' + this.inputBec.last_name
      let cart = this.cart
      let orderdetails = []

      if (cart) {
        orderdetails = cart.map((item) => ({
          sku: item.selectedOption ? item.selectedOption.option1.sku : item.id,
          sku_gift: item.selectedOption ? item.selectedOption.option2.sku : '',
          sku_gift_enforce: item.selectedOption
            ? item.selectedOption.option3.sku
            : '',
          quantity: item.quantity,
          amount: item.priceBeforeVat
        }))
      }

      let data = {
        address: {
          social_id: this.userid,
          facebook_id: this.userid,
          name: customerName,
          address: address,
          phone: this.customerPhone,
          email: this.inputBec.email,
          postcode: this.shippingAddress2.zipcode
        },
        orderdetails: orderdetails,
        ticket_code: this.voucherCode ? this.voucherCode : '',
        page_id: this.pageProfile.pageid
      }

      let url = `${config.thailandpostmart.serverUrl}cart/verify`
      let auth = config.thailandpostmart.auth
      var result = null

      try {
        vm.loading = true
        let response = await axios.post(url, data, {
          headers: auth
        })

        if (response && response.data.responsecode == '200') {
          result = response.data.data
        } else {
          console.log(response)
          this.$swal({
            title: vm.$t('Error'),
            text: response.data.reason.res
              ? response.data.reason.res
              : response.data.reason,
            type: 'error',
            confirmButtonText: vm.$t('Confirm'),
            cancelButtonText: vm.$t('Cancel'),
            reverseButtons: true
          })
        }
      } catch (error) {
        /* eslint-disable */
        console.log(error)
      } finally {
        vm.loading = false
      }

      return result
    },
    async THPostMartSubmitOrder() {
      var vm = this
      let customerName =
        this.inputBec.first_name + ' ' + this.inputBec.last_name
      let cart = this.cart
      let orderdetails = []
      let order_id = moment().format('YYYYMMDDHHmmss')
      let sale_date = moment().format('YYYY/MM/DD HH:mm:ss')

      var payment
      if (vm.shippingType && vm.shippingType.type == 'cjlogistics_charge') {
        payment = '2c2p'
      } else {
        payment = vm.transferType
      }

      if (cart) {
        orderdetails = cart.map((item) => ({
          sku: item.selectedOption ? item.selectedOption.option1.sku : item.id,
          sku_gift: item.selectedOption ? item.selectedOption.option2.sku : '',
          sku_gift_enforce: item.selectedOption
            ? item.selectedOption.option3.sku
            : '',
          quantity: item.quantity,
          amount: item.priceBeforeVat
        }))
      }

      const app = this.getAppTypeFromUser(this.userid)

      let data = {
        order_id: order_id,
        social_type: app,
        social_id: this.userid,
        payment_type: payment,
        sale_date: sale_date,
        address: {
          name: customerName,
          address: this.shippingAddress,
          province_name: this.shippingAddress2.province,
          amphur_name: this.shippingAddress2.district,
          tumbol_name: this.shippingAddress2.sub_district,
          postcode: this.shippingAddress2.zipcode,
          phone: this.customerPhone,
          remark: this.remark,
          email: this.inputBec.email
        },
        ticket_code: this.voucherCode,
        orderdetails: orderdetails,
        page_id: this.pageProfile.pageid
      }

      // console.log("data: ",data);

      let url = `${config.thailandpostmart.serverUrl}cart/orderzwiz`
      let auth = config.thailandpostmart.auth
      var result = null

      try {
        let response = await axios.post(url, data, {
          headers: auth
        })

        if (response && response.data.responsecode == '200') {
          result = response.data.data
        } else if (
          response &&
          response.data.responsecode == '400' &&
          response.data.reason &&
          response.data.reason.res &&
          response.data.reason.res[0]
        ) {
          this.$swal.fire({
            type: 'error',
            text: response.data.reason.res[0]
          })
        }
      } catch (error) {
        /* eslint-disable */
        console.log(error)
      }

      return result
    },
    async onCheckVoucher() {
      if (!['tero'].includes(this.pageProfile.type)) {
        const responseData = await this.THPostMartVerifyCart()
        if (
          responseData[0] &&
          responseData[0].desc &&
          responseData[0].desc[0] &&
          Object.keys(responseData[0].desc[0]).length
        ) {
          this.$store.state.thpostmartVerifyCartResult = responseData
          this.onUpdateTotal(responseData[0].desc[0])
        }
      }
    }
  },
  watch: {
    shippingAddress: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        if (!['tero'].includes(this.pageProfile.type)) {
          this.handleCheckShippingPrice()
        }
      }
    }
  }
}
</script>
